/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class VirtualMachineAgentsFilter {
    getFixupPrototypeFunction() { return VirtualMachineAgentsFilter.fixupPrototype; }

    static newInstance(model: Partial<VirtualMachineAgentsFilter>): VirtualMachineAgentsFilter {
        let obj = Object.assign(new VirtualMachineAgentsFilter(), model);
        VirtualMachineAgentsFilter.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<VirtualMachineAgentsFilter>): VirtualMachineAgentsFilter {
        if (!model) return null;
        return VirtualMachineAgentsFilter.newInstance(<VirtualMachineAgentsFilter> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: VirtualMachineAgentsFilter) {
        if (!obj) return;

        models.VirtualMachineAgentsFilter.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: VirtualMachineAgentsFilter): boolean {
        Object.setPrototypeOf(obj, VirtualMachineAgentsFilter.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Cloud Provider to select
     */
    cloud: models.CloudServiceName;

    /**
     * Specify the tenant ID. This is a unique ID and can be retrieved using the List Tenants API.
     */
    tenant_ids: Array<string>;

    agents: Array<models.VirtualMachineAgentsType>;

    /**
     * Specify the Service Account IDs.
     */
    service_account_ids: Array<string>;

    /**
     * Text query to filter agents.
     */
    text_query: string;

}
